import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const Reviews = () => {
    return (
        <>
            <Header as="h1" id="reviews-header">Reviews</Header>
        </>
    );
};

export default Reviews;